import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { getBaseDomain } from "@eyeo/webext-ad-filtering-solution/adblockpluscore/lib/url";
import ServerMessages from "~/servermessages";
import { getAAStatus } from "~/telemetry/background";
async function handlePageLoaded(page) {
    if (typeof page.id === "undefined" || page.id === browser.tabs.TAB_ID_NONE) {
        return;
    }
    const domains = await ewe.experiments.getFlag("pageview-metrics:domains");
    if (!isStringArray(domains) || !domains.length) {
        return;
    }
    const domain = getBaseDomain(page.url.hostname);
    if (!domains.includes(domain)) {
        return;
    }
    let pageState = 0;
    pageState |= (await isTabAllowlisted(page.id)) ? 1 : 0;
    pageState <<= 1;
    pageState |= (await isTabPrivate(page.id)) ? 1 : 0;
    pageState <<= 1;
    pageState |= (await isAcceptableAdsEnabled()) ? 1 : 0;
    ServerMessages.recordAnonymousMessage("pageview", "stats", null, {
        misc_text: domain,
        var: pageState,
    });
}
async function isAcceptableAdsEnabled() {
    const status = await getAAStatus();
    return status === "1" || status === "2";
}
function isStringArray(candidate) {
    return Array.isArray(candidate) && (!candidate.length || typeof candidate[0] === "string");
}
async function isTabPrivate(tabId) {
    const tab = await browser.tabs.get(tabId);
    return tab.incognito;
}
async function isTabAllowlisted(tabId) {
    const allowingFilters = await ewe.filters.getAllowingFilters(tabId);
    return allowingFilters.length > 0;
}
async function handleBTAADetectionEvent(details) {
    const domains = await ewe.experiments.getFlag("pageview-metrics:domains");
    if (!isStringArray(domains) || !domains.length) {
        return;
    }
    const domain = getBaseDomain(details.siteId);
    if (!domains.includes(domain)) {
        return;
    }
    let packedDetails = 0;
    packedDetails |= details.isAAPV ? 1 : 0;
    packedDetails <<= 1;
    packedDetails |= details.ab ? 1 : 0;
    packedDetails <<= 1;
    packedDetails |= details.acceptable ? 1 : 0;
    ServerMessages.recordAnonymousMessage("btaa_detection", "stats", null, {
        misc_text: domain,
        sid: details.sessionId,
        var: packedDetails,
    });
}
export function start() {
    ext.pages.onLoaded.addListener(handlePageLoaded);
    ewe.cdp.onBTAADetectionEvent.addListener(handleBTAADetectionEvent);
}
